import React from "react";
import { FiStar } from "react-icons/fi";
import { Thumbs } from "./thumbs";

export const ProjectItem = ({ item }) => {
 
    return (
        <li >
            <div className="project flex">
                <div className="list">
                    <div className="owner">
                        <a href={`/users/${item.user._id}`} target="_blank" rel="noreferrer" className="flex-column" >
                            <div className="name">{item.user.name}</div>

                            {item?.avatar && <img alt="" src={`/assets/images/faces/${item.avatar}.png`} draggable="false" />}
                            {!item?.avatar && item.user.avatar && <img src={`${item.user.avatar}`} alt={item.user.name} draggable="false" />}
                            {!item?.avatar && !item.user.avatar && <img src="/assets/images/faces/default.svg" alt={item.user.name} draggable="false" />}
                            <p className="date">{item.user.date}</p>
                        </a>
                        {true && (
                            <Thumbs
                                id={0}
                                likes={item.user.like}
                                dislikes={item.user.dislike}
                            />
                        )}
                    </div>
                    <div className="detail">
                        <div className="info">
                            <a href={`/projects/single`} className="flex"> 
                                <div className="title">{item.title} {item.privacy && <div className="private">Private</div>} </div>
                            </a> 
                            <div className="stars">
                                {Array.from(Array(item.star)).map(star=><FiStar />)}
                                <p className="reviews">{item.reviews} Reviews</p>
                            </div>
                            <ul>
                                {item.sector?.length > 0 && <li><p>sector: </p><b>{item.sector[0]?.title}</b></li>}
                                {item.job?.length > 0 && <li><p>type: </p><b>{item?.job[0]?.title}</b></li>}
                                {item.era?.length > 0 && <li><p>era: </p><b>{item.era?.length > 0 && item.era[0]?.title}</b></li>}
                            </ul>
                        </div>
                        
                    </div>
                </div>
                <div className="cover">
                    {item?.img && <img alt="" src={`/assets/images/projects/${item.img}.jpg`} />}
                    {item.images?.length > 0 && <img src={`/assets/images/${item.images?.find((i) => i.default === true)?.path || item.images[0]?.path}`} draggable="false" alt={item.title} />}
                </div>
            </div>
        </li>
    )
}
 
